const PostallyAddressable = [
  {
    id: "Y",
    gpText: "Yes",
    osText: "Yes",
  },
  {
    id: "N",
    gpText: "No",
    osText: "No",
  },
  {
    id: "P",
    gpText: "Pseudo postcode",
    osText: undefined,
  },
  {
    id: "A",
    gpText: "Assumed post town and postcode",
    osText: undefined,
  },
  {
    id: "L",
    gpText: "Large user postcode",
    osText: "Large user postcode",
  },
];

export default PostallyAddressable;
